import {UWM_INIT_MARKET_LOCALE} from '@/consts/eventTypes';

const _dispatchCustomEvent = (command: string, payload: any) => {
    if (!command) {
        return undefined;
    }

    const customEvent = new CustomEvent('UwmCommand', {
        detail: {
            command: command,
            payload: payload,
        },
    });
    document.dispatchEvent(customEvent);
};

const dispatchMarketLocaleEvent = ({
    marketCode = 'uat',
    languageCode = 'en',
    deviceType = '',
    type = '',
    ...rest
}: Record<string, any>) =>
    _dispatchCustomEvent(UWM_INIT_MARKET_LOCALE, {
        marketCode,
        languageCode,
        deviceType,
        type,
        ...rest,
    });

const dispatchers = {
    dispatchMarketLocaleEvent,
};

// @ts-expect-error
window.dispatchers = dispatchers;

export default dispatchers;
